// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G_oTX2t3FoLUnO {
  display: flex;
  flex-direction: row;
}
.H2t1ErLunidGwn {
  display: flex;
  flex-direction: column;
}
.kCMhoovUShU3f5 {
  position: relative;
}
.eSxPrFhGIapuh9 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.IfpvKPX8q6nfER {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.l_ACdizgZu7qSg {
  display: grid;
}
.nGxTVskizG33Qz {
  display: flex;
  flex-direction: column;
  justify-content: left;
  gap: 8px;
}
.CRzLwldedgbpl_ {
  display: grid;
  grid-auto-rows: 40px auto;
  margin-bottom: 8px;
  row-gap: 12px;
}
.z_2dpunNWoawUd {
  max-height: 40px;
  align-items: center;
  display: grid;
  grid-template-columns: 40px 1fr;
}
.k8hoit1x4fIgen {
  display: grid;
  grid-template-columns: 1fr auto;
}
.yTJdMKv0yx6M1b {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.tbaLwxmcmFFhij {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin-left: 8px;
  max-height: 40px;
  text-overflow: ellipsis;
}
.tbaLwxmcmFFhij.OPqBrmQCn800du {
  height: 18px;
  margin-bottom: 4px;
  min-width: 100px;
}
.RJOvcaXofwJcob {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin-left: 8px;
  max-height: 20px;
  text-overflow: ellipsis;
}
.ffpHDGXWHCCRmI {
  font-size: 14px;
  letter-spacing: -0.3px;
  line-height: normal;
  margin-left: 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: no-wrap;
}
.ef5Ow3wEp2hV_4 {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  height: 40px;
  width: 40px;
}
.lDLnCCYDs47Y8u {
  display: flex;
  flex-wrap: wrap;
  margin-top: auto;
  gap: 8px;
}
.k9ojPYuL3PPdHn {
  align-items: center;
  border-radius: 3px;
  color: var(--ds-text-subtle, #44546f);
  display: flex;
  font-size: 12px;
  height: 24px;
  line-height: 14px;
  white-space: nowrap;
  padding: 0 8px;
}
.k9ojPYuL3PPdHn.vLZSlh9P1ty7yX {
  background-color: var(--ds-background-accent-blue-subtlest, #e9f2ff);
}
.DZRnKlHLfAcIE3 {
  margin-right: 8px;
}
.Ck9gmZ2Uw87Mmq {
  background-color: var(--ds-background-neutral, #091e420f);
  border-radius: 4px;
  padding: 8px;
  width: 100%;
}
.Ck9gmZ2Uw87Mmq:hover {
  background: var(--ds-background-neutral-hovered, rgba(0, 0, 0, 0.05));
}
.zFrCb4laTkOb9D {
  background: var(--ds-surface-sunken, #f7f8f9);
  border-radius: 4px;
  display: grid;
  grid-template-rows: auto 1fr;
}
.SWO8Z0NxwWvvzb {
  padding: 10px;
}
.aRLylRBUxfePmQ {
  height: 240px;
  width: 100%;
  border-radius: 4px 4px 0 0;
  object-fit: cover;
}
@keyframes eJBzYjHdvkYRBw {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
.OPqBrmQCn800du {
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: eJBzYjHdvkYRBw;
  background: var(--ds-skeleton, linear-gradient(to right, #EBECF0 8%, #DFE1E6 18%, #EBECF0 33%));
  background-size: 800px 104px;
}
.z44iXTUrr29ixq {
  height: 24px;
  min-width: 64px;
  margin-top: 3px;
  border-radius: 3px;
}
.directory-individual-listing .KkbpiBe6uuSR2V {
  margin-left: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRow": `G_oTX2t3FoLUnO`,
	"flexColumn": `H2t1ErLunidGwn`,
	"relative": `kCMhoovUShU3f5`,
	"flexRowSpaceBetween": `eSxPrFhGIapuh9`,
	"flexColumnCenter": `IfpvKPX8q6nfER`,
	"gridColumn": `l_ACdizgZu7qSg`,
	"descriptionAtomGrid": `nGxTVskizG33Qz`,
	"listingAtomGrid": `CRzLwldedgbpl_`,
	"logoNameGrid": `z_2dpunNWoawUd`,
	"twoColumnGrid": `k8hoit1x4fIgen`,
	"nameContainer": `yTJdMKv0yx6M1b`,
	"name": `tbaLwxmcmFFhij`,
	"loadingSkeleton": `OPqBrmQCn800du`,
	"listingName": `RJOvcaXofwJcob`,
	"subtitle": `ffpHDGXWHCCRmI`,
	"icon": `ef5Ow3wEp2hV_4`,
	"badges": `lDLnCCYDs47Y8u`,
	"pupBadge": `k9ojPYuL3PPdHn`,
	"darkModeBadge": `vLZSlh9P1ty7yX`,
	"usageBadgeIcon": `DZRnKlHLfAcIE3`,
	"descriptionAtom": `Ck9gmZ2Uw87Mmq`,
	"featuredAtomContainer": `zFrCb4laTkOb9D`,
	"featuredAtom": `SWO8Z0NxwWvvzb`,
	"heroImage": `aRLylRBUxfePmQ`,
	"loadingSkeletonAnimation": `eJBzYjHdvkYRBw`,
	"loadingSkeletonButton": `z44iXTUrr29ixq`,
	"pupIntegrationBadge": `KkbpiBe6uuSR2V`
};
export default ___CSS_LOADER_EXPORT___;
